import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { ExistingBlackoutDate } from '~/types/stopsell';

interface BlackoutDatesByRoomTypes {
  isLoading: boolean;
  isError: boolean;
  byRoomType: Record<string, Array<ExistingBlackoutDate>>;
}

export function useBlackoutDatesByRoomTypes(
  propertyId: string,
  roomTypes: Array<App.RoomType>,
): BlackoutDatesByRoomTypes {
  const roomTypeIds = roomTypes.map((rt) => rt.id);

  const {
    data = {},
    isError,
    isLoading,
  } = useQuery({
    queryKey: ['blackoutDates', propertyId, roomTypeIds],
    queryFn: async (): Promise<Record<string, Array<ExistingBlackoutDate>>> => {
      const { result: response } = (await ReservationService.getBlackoutDatesBulk(propertyId, roomTypeIds)) as {
        result: Record<string, Array<App.BulkBlackoutDate>>;
      };

      const byRoomType: Record<string, Array<ExistingBlackoutDate>> = {};
      for (const [roomTypeId, dates] of Object.entries(response)) {
        byRoomType[roomTypeId] = dates.map((d) => ({ start: d.start_date, end: d.end_date, blocks: d.blocks ?? [] }));
      }

      return byRoomType;
    },
    enabled: !!propertyId && roomTypeIds.length > 0,
  });

  return { isLoading, isError, byRoomType: data };
}
